/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2022
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import UseSpecType from './UseSpecType';
import ObjectFactory from './ObjectFactory';
import PropertySetter from './PropertySetter';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (static) // UseSpecType
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectFactory (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (static) // isDataSourceOverrideEmpty, populateOverrideFields

/**
 * This class provides a set of static utility APIs for dynamic schemas. This class will be translated to JavaScript
 * @author  alan-tran
 */
export default class DynamicSchemaUtils extends BaseMoserObject{

	static NULL_STRING = "null";

	static EMPTY_STRING = "";

	static REGX_DOT = "\\.";



	/**
	 * Creates and populates a data source override object
	 * @param {Module} module  	 current data module
	 * @param {UseSpec} useSpec 	 useSpec object
	 * @param {Module} baseModule  database module
	 */
	static createDataSourceOverride(module, useSpec, baseModule) {
		if (!module || !useSpec || UseSpecType.DATABASE != useSpec.getType() || !baseModule) {
			return null;
		}
		var factory = new ObjectFactory();
		var dataSourceOverride = factory.createModuleUseSpecDataSourceOverride();
		var container = baseModule.getContainer();
		DynamicSchemaUtils.populateDataSourceOverride(dataSourceOverride, container);
		if (DynamicSchemaUtils.isDataSourceOverrideEmpty(dataSourceOverride)) {
			return null;
		}
		return dataSourceOverride;
	}

	/**
	 * Returns true if the dataSourceOverride has no original values and has not been overridden.
	 * @param {DataSourceOverride} dataSourceOverride 	override object
	 */
	static isDataSourceOverrideEmpty(dataSourceOverride) {
		return PropertySetter.isDataSourceOverrideEmpty(dataSourceOverride);
	}

	/**
	 * Returns if the field is being overridden. Assumes null/undefined value equals false. Used since translator cannot translate Boolean.TRUE or Boolean.FALSE
	 * @param  Boolean
	 */
	static isOverride(bool) {
		if (bool == null) {
			return false;
		}
		return bool;
	}

	/**
	 * Populates a data source override object with data source information from a base module container id
	 * @param {DataSourceOverride} dataSourceOverride  	override object
	 * @param {String} container   			identifier
	 */
	static populateDataSourceOverride(dataSourceOverride, container) {
		var originalCMDataSource = DynamicSchemaUtils.extractCMDataSource(container);
		var originalCatalog = DynamicSchemaUtils._processValue(DynamicSchemaUtils.extractCatalog(container));
		var originalSchema = DynamicSchemaUtils._processValue(DynamicSchemaUtils.extractSchema(container));
		if (originalCMDataSource != null) {
			dataSourceOverride.setOriginalCMDataSource(originalCMDataSource);
		}
		if (originalCatalog != null) {
			dataSourceOverride.setOriginalCatalog(originalCatalog);
		}
		if (originalSchema != null) {
			dataSourceOverride.setOriginalSchema(originalSchema);
		}
		PropertySetter.populateOverrideFields(dataSourceOverride, originalCMDataSource, originalCatalog, originalSchema, DynamicSchemaUtils.isOverride(dataSourceOverride.isOverrideCMDataSource()), DynamicSchemaUtils.isOverride(dataSourceOverride.isOverrideCatalog()), DynamicSchemaUtils.isOverride(dataSourceOverride.isOverrideSchema()));
	}

	/**
	 * Returns true if the container identifier separated by at least four dots
	 * @param {String} containerId  	physical or base module container identifier
	 */
	static isValidContainerId(containerId) {
		if (containerId == null) {
			return false;
		}
		var parts = containerId.split(new RegExp("\\."));
		return parts.length >= 4;
	}

	/**
	 * Returns Content Manager Source name from the container identifier
	 * @param {String} containerId  	physical or base module container identifier
	 */
	static extractCMDataSource(containerId) {
		if (DynamicSchemaUtils.isValidContainerId(containerId)) {
			return containerId.split(new RegExp("\\."))[0];
		}
		return null;
	}

	/**
	 * Returns catalog name from the container identifier
	 * @param {String} containerId  	physical or base module container identifier
	 */
	static extractCatalog(containerId) {
		if (DynamicSchemaUtils.isValidContainerId(containerId)) {
			return containerId.split(new RegExp("\\."))[2];
		}
		return null;
	}

	/**
	 * Returns schema name from the container identifier
	 * @param {String} containerId  	physical or base module container identifier
	 */
	static extractSchema(containerId) {
		if (DynamicSchemaUtils.isValidContainerId(containerId)) {
			return containerId.split(new RegExp("\\."))[3];
		}
		return null;
	}

	static _processValue(value) {
		if ("null" == value) {
			return "";
		}
		return value;
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/DynamicSchemaUtils.js